import { style } from 'typestyle'
import { important } from 'csx'
export const f14i = style({ fontSize: important('14px') })
